import { render, staticRenderFns } from "./TerritoryTree.vue?vue&type=template&id=9689481e&scoped=true&"
import script from "./TerritoryTree.vue?vue&type=script&lang=js&"
export * from "./TerritoryTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9689481e",
  null
  
)

export default component.exports